"use strict";

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./BarLoader", "./BeatLoader", "./BounceLoader", "./CircleLoader", "./ClipLoader", "./ClimbingBoxLoader", "./DotLoader", "./FadeLoader", "./GridLoader", "./HashLoader", "./MoonLoader", "./PacmanLoader", "./PropagateLoader", "./PulseLoader", "./RingLoader", "./RiseLoader", "./RotateLoader", "./ScaleLoader", "./SyncLoader"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./BarLoader"), require("./BeatLoader"), require("./BounceLoader"), require("./CircleLoader"), require("./ClipLoader"), require("./ClimbingBoxLoader"), require("./DotLoader"), require("./FadeLoader"), require("./GridLoader"), require("./HashLoader"), require("./MoonLoader"), require("./PacmanLoader"), require("./PropagateLoader"), require("./PulseLoader"), require("./RingLoader"), require("./RiseLoader"), require("./RotateLoader"), require("./ScaleLoader"), require("./SyncLoader"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.BarLoader, global.BeatLoader, global.BounceLoader, global.CircleLoader, global.ClipLoader, global.ClimbingBoxLoader, global.DotLoader, global.FadeLoader, global.GridLoader, global.HashLoader, global.MoonLoader, global.PacmanLoader, global.PropagateLoader, global.PulseLoader, global.RingLoader, global.RiseLoader, global.RotateLoader, global.ScaleLoader, global.SyncLoader);
    global.undefined = mod.exports;
  }
})(void 0, function (exports, _BarLoader, _BeatLoader, _BounceLoader, _CircleLoader, _ClipLoader, _ClimbingBoxLoader, _DotLoader, _FadeLoader, _GridLoader, _HashLoader, _MoonLoader, _PacmanLoader, _PropagateLoader, _PulseLoader, _RingLoader, _RiseLoader, _RotateLoader, _ScaleLoader, _SyncLoader) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SyncLoader = exports.ScaleLoader = exports.RotateLoader = exports.RiseLoader = exports.RingLoader = exports.PulseLoader = exports.PropagateLoader = exports.PacmanLoader = exports.MoonLoader = exports.HashLoader = exports.GridLoader = exports.FadeLoader = exports.DotLoader = exports.ClimbingBoxLoader = exports.ClipLoader = exports.CircleLoader = exports.BounceLoader = exports.BeatLoader = exports.BarLoader = undefined;

  var _BarLoader2 = _interopRequireDefault(_BarLoader);

  var _BeatLoader2 = _interopRequireDefault(_BeatLoader);

  var _BounceLoader2 = _interopRequireDefault(_BounceLoader);

  var _CircleLoader2 = _interopRequireDefault(_CircleLoader);

  var _ClipLoader2 = _interopRequireDefault(_ClipLoader);

  var _ClimbingBoxLoader2 = _interopRequireDefault(_ClimbingBoxLoader);

  var _DotLoader2 = _interopRequireDefault(_DotLoader);

  var _FadeLoader2 = _interopRequireDefault(_FadeLoader);

  var _GridLoader2 = _interopRequireDefault(_GridLoader);

  var _HashLoader2 = _interopRequireDefault(_HashLoader);

  var _MoonLoader2 = _interopRequireDefault(_MoonLoader);

  var _PacmanLoader2 = _interopRequireDefault(_PacmanLoader);

  var _PropagateLoader2 = _interopRequireDefault(_PropagateLoader);

  var _PulseLoader2 = _interopRequireDefault(_PulseLoader);

  var _RingLoader2 = _interopRequireDefault(_RingLoader);

  var _RiseLoader2 = _interopRequireDefault(_RiseLoader);

  var _RotateLoader2 = _interopRequireDefault(_RotateLoader);

  var _ScaleLoader2 = _interopRequireDefault(_ScaleLoader);

  var _SyncLoader2 = _interopRequireDefault(_SyncLoader);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var BarLoader = exports.BarLoader = _BarLoader2["default"];
  var BeatLoader = exports.BeatLoader = _BeatLoader2["default"];
  var BounceLoader = exports.BounceLoader = _BounceLoader2["default"];
  var CircleLoader = exports.CircleLoader = _CircleLoader2["default"];
  var ClipLoader = exports.ClipLoader = _ClipLoader2["default"];
  var ClimbingBoxLoader = exports.ClimbingBoxLoader = _ClimbingBoxLoader2["default"];
  var DotLoader = exports.DotLoader = _DotLoader2["default"];
  var FadeLoader = exports.FadeLoader = _FadeLoader2["default"];
  var GridLoader = exports.GridLoader = _GridLoader2["default"];
  var HashLoader = exports.HashLoader = _HashLoader2["default"];
  var MoonLoader = exports.MoonLoader = _MoonLoader2["default"];
  var PacmanLoader = exports.PacmanLoader = _PacmanLoader2["default"];
  var PropagateLoader = exports.PropagateLoader = _PropagateLoader2["default"];
  var PulseLoader = exports.PulseLoader = _PulseLoader2["default"];
  var RingLoader = exports.RingLoader = _RingLoader2["default"];
  var RiseLoader = exports.RiseLoader = _RiseLoader2["default"];
  var RotateLoader = exports.RotateLoader = _RotateLoader2["default"];
  var ScaleLoader = exports.ScaleLoader = _ScaleLoader2["default"];
  var SyncLoader = exports.SyncLoader = _SyncLoader2["default"];
});